import AlertDetail from '../alerts/alertDetail'
import AlertList from '../alerts/alertList'
import AlertSetting from '../alerts/alertSetting'
import CartAndOrders from '../cartAndOrders'
import OrderConfirmation from '../cartAndOrders/orderConfirmation'
import CompanyProfile from '../companyAnalysis/companyProfile'
import FilingStatus from '../companyAnalysis/filingStatus'
import FinancialAnalysis from '../companyAnalysis/financial/financialAnalysis'
import FinancialStatements from '../companyAnalysis/financial/financialStatements'
import IndustryAnalysis from '../companyAnalysis/industry/industryAnalysis'
import IndustryOverview from '../companyAnalysis/industry/industryOverview'
import NewsAndSocials from '../companyAnalysis/newsAndSocials'
import OwnershipAndGroup from '../companyAnalysis/ownershipAndGroup'
import PeerAnalysis from '../companyAnalysis/peerAnalysis'
import CorporatePerformanceScore from '../companyAnalysis/score/corporatePerformanceScore'
import CorporateRiskScore from '../companyAnalysis/score/corporateRiskScore'
import StandardComponentScore from '../companyAnalysis/score/standardComponentScore'
import Summary from '../companyAnalysis/summary'
import EntityMap from '../connectMap/entityMap'
import InterconnectionMap from '../connectMap/interconnectionMap'
import Dashboard from '../dashboard'
import { LatestReportsTable } from '../dashboard/components/latestReports/table'
import DownloadedFiles from '../library/downloadedFiles'
import FilteredSetting from '../library/filteredCompanies/filterSetting'
import FilteredCompanies from '../library/filteredCompanies/filteredCompany'
import FollowingList from '../library/followingList'
import DetailsPortfolios from '../library/savedPortfolios/detailsPortfolios'
import SavedPortfolios from '../library/savedPortfolios/portfoliosOverview'
import PortfolioFinance from '../portfolioInsights/finance'
import PortfolioScore from '../portfolioInsights/score'
import PortfolioSegment from '../portfolioInsights/segment'
import PortfolioSummary from '../portfolioInsights/summary'
import DomesticSearchPreview from '../search/domesticSearch/preview'
import DomesticSearch from '../search/domesticSearch/searchList'
import { InternationalSearchPreview } from '../search/internationalSearch/preview'
import { InternationalSearch } from '../search/internationalSearch/searchList'
import SystemNotifications from '../systemNotifications'
import SystemNotificationsSettings from '../systemNotifications/systemNotificationsSettings'
import DynamicReport from '../tool/dynamicReport'
import Screening from '../tool/screening'
import { SettingPreferences } from '../userManagement/settingPreferences'
import { SubscriptionPayment } from '../userManagement/subscriptionPayment'
import { PackageList } from '../userManagement/subscriptionPayment/common/packageList'
import { ViewDetailPlan } from '../userManagement/subscriptionPayment/common/viewDetailPlans'
import { OrderDetail } from '../userManagement/subscriptionPayment/orderManagement/orderDetail'
import { RequestDetail } from '../userManagement/subscriptionPayment/packageSubManagement/detail'
import { UserProfile } from '../userManagement/userProfile'

export const SIGN_IN_CALLBACK_ROUTE = '/signin-callback'

export const COMPONENTS = {
  alerts: {
    route: '/alerts',
    components: {
      alertList: {
        route: '/alerts',
        name: 'alerts.list',
        disableFooterInLayout: true,
        render: () => <AlertList />,
      },
      alertDetail: {
        route: '/alerts/:alertId',
        name: 'alerts.detail',
        disableFooterInLayout: true,
        render: () => <AlertDetail />,
      },
      alertSetting: {
        route: '/alerts/settings',
        name: 'alerts.settings',
        disableFooterInLayout: true,
        render: () => <AlertSetting />,
      },
    },
  },
  cartAndOrders: {
    route: '/cartAndOrders',
    name: 'cartAndOrders',
    disableFooterInLayout: true,
    render: () => <CartAndOrders />,
    components: {
      confirmation: {
        route: '/cartAndOrders/confirmation',
        name: 'cartAndOrders.confirmation',
        render: () => <OrderConfirmation />,
        disableFooterInLayout: true,
      },
    },
  },
  companyAnalysis: {
    route: '/companyAnalysis',
    components: {
      summary: {
        route: '/companyAnalysis/summary',
        name: 'companyAnalysis.summary',
        hiddenFooter: true,
        render: () => <Summary />,
      },
      companyProfile: {
        route: '/companyAnalysis/companyProfile',
        name: 'companyAnalysis.companyProfile',
        hiddenFooter: true,
        render: () => <CompanyProfile />,
      },
      ownershipAndGroup: {
        route: '/companyAnalysis/ownershipAndGroup',
        name: 'companyAnalysis.ownershipAndGroup',
        hiddenFooter: true,
        render: () => <OwnershipAndGroup />,
      },
      filingStatus: {
        route: '/companyAnalysis/filingStatus',
        name: 'companyAnalysis.filingStatus',
        hiddenFooter: true,
        render: () => <FilingStatus />,
      },
      newsAndSocials: {
        route: '/companyAnalysis/newsAndSocials',
        name: 'companyAnalysis.newsAndSocials',
        hiddenFooter: true,
        render: () => <NewsAndSocials />,
      },
      financial: {
        components: {
          financialStatements: {
            route: '/companyAnalysis/financial/financialStatements',
            name: 'companyAnalysis.financial.financialStatements',
            hiddenFooter: true,
            render: () => <FinancialStatements />,
          },
          financialAnalysis: {
            route: '/companyAnalysis/financial/financialAnalysis',
            name: 'companyAnalysis.financial.financialAnalysis',
            hiddenFooter: true,
            render: () => <FinancialAnalysis />,
          },
        },
      },
      score: {
        components: {
          standard: {
            route: '/score',
            name: 'score.standard',
            hiddenFooter: true,
            render: () => <StandardComponentScore />,
          },
          corporateRiskScore: {
            route: '/companyAnalysis/corporateRiskScore',
            name: 'companyAnalysis.corporateRiskScore',
            hiddenFooter: true,
            render: () => <CorporateRiskScore />,
          },
          corporatePerformanceScore: {
            route: '/companyAnalysis/corporatePerformanceScore',
            name: 'companyAnalysis.corporatePerformanceScore',
            hiddenFooter: true,
            render: () => <CorporatePerformanceScore />,
          },
        },
      },
      peerAnalysis: {
        route: '/companyAnalysis/peerAnalysis',
        name: 'companyAnalysis.peerAnalysis',
        hiddenFooter: true,
        render: () => <PeerAnalysis />,
      },
      industry: {
        components: {
          industryOverview: {
            route: '/companyAnalysis/industry/industryOverview',
            name: 'companyAnalysis.industry.industryOverview',
            hiddenFooter: true,
            render: () => <IndustryOverview />,
          },
          industryAnalysis: {
            route: '/companyAnalysis/industry/industryAnalysis',
            name: 'companyAnalysis.industry.industryAnalysis',
            hiddenFooter: true,
            render: () => <IndustryAnalysis />,
          },
        },
      },
    },
  },
  dashboard: {
    components: {
      dashboard: {
        route: '/dashboard',
        name: 'dashboard',
        render: () => <Dashboard />,
        minWidthLayout: 1194,
        hiddenFooter: true,
      },
      latestReports: {
        route: '/dashboard/latestReports',
        name: 'dashboard',
        hiddenFooter: true,
        render: () => <LatestReportsTable />,
      },
    },
  },
  domesticSearch: {
    route: '/domesticSearch',
    name: 'domesticSearch',
    disableFooterInLayout: true,
    render: () => <DomesticSearch />,
    components: {
      domesticSearchPreview: {
        route: '/domesticSearch/preview',
        name: 'domesticSearch.preview',
        disableFooterInLayout: true,
        render: () => <DomesticSearchPreview />,
      },
    },
  },
  dynamicReport: {
    route: '/dynamicReport',
    name: 'dynamicReport',
    render: () => <DynamicReport />,
    disableFooterInLayout: true,
  },
  internationalSearch: {
    route: '/internationalSearch',
    name: 'internationalSearch',
    render: () => <InternationalSearch />,
    components: {
      internationalSearchPreview: {
        route: '/internationalSearch/preview',
        name: 'internationalSearch.preview',
        render: () => <InternationalSearchPreview />,
      },
    },
  },
  library: {
    route: '/library',
    components: {
      savedPortfolios: {
        components: {
          savedPortfolio: {
            route: '/library/savedPortfolios',
            name: 'library.savedPortfolios.savedPortfolio',
            hiddenFooter: true,
            borderTopWhenResponsive: true,
            render: () => <SavedPortfolios />,
          },
          detailsPortfolio: {
            route: '/library/detailsPortfolio',
            name: 'library.savedPortfolios.detailsPortfolio',
            hiddenFooter: true,
            borderTopWhenResponsive: true,
            render: () => <DetailsPortfolios />,
          },
        },
      },
      filteredCompanies: {
        components: {
          filteredCompany: {
            route: '/library/filteredCompanies',
            name: 'library.filteredCompanies.filteredCompany',
            hiddenFooter: true,
            borderTopWhenResponsive: true,
            render: () => <FilteredCompanies />,
          },
          filteredCompanySetting: {
            route: '/library/filteredCompanies/setting',
            name: 'library.filteredCompanies.filteredCompanySetting',
            hiddenFooter: true,
            render: () => <FilteredSetting />,
          },
        },
      },
      downloadFiles: {
        route: '/library/downloadFiles',
        name: 'library.downloadFiles',
        hiddenFooter: true,
        borderTopWhenResponsive: true,
        render: () => <DownloadedFiles />,
      },
      followingList: {
        route: '/library/followingList',
        name: 'library.followingList',
        hiddenFooter: true,
        borderTopWhenResponsive: true,
        render: () => <FollowingList />,
      },
    },
  },
  portfolioInsights: {
    route: '/portfolioInsights',
    components: {
      summary: {
        route: '/portfolioInsights/summary',
        name: 'portfolioInsights.summary',
        hiddenFooter: true,
        borderTopWhenResponsive: true,
        disableFooterInLayout: true,
        render: () => <PortfolioSummary />,
      },
      finance: {
        route: '/portfolioInsights/finance',
        name: 'portfolioInsights.finance',
        hiddenFooter: true,
        borderTopWhenResponsive: true,
        disableFooterInLayout: true,
        render: () => <PortfolioFinance />,
      },
      score: {
        route: '/portfolioInsights/score',
        name: 'portfolioInsights.score',
        hiddenFooter: true,
        borderTopWhenResponsive: true,
        disableFooterInLayout: true,
        render: () => <PortfolioScore />,
      },
      segment: {
        route: '/portfolioInsights/segment',
        name: 'portfolioInsights.segment',
        hiddenFooter: true,
        borderTopWhenResponsive: true,
        disableFooterInLayout: true,
        render: () => <PortfolioSegment />,
      },
    },
  },
  systemNotifications: {
    route: '/systemNotifications',
    name: 'systemNotifications',
    hiddenFooter: true,
    render: () => <SystemNotifications />,
    components: {
      systemNotificationsSettings: {
        route: '/systemNotifications/settings',
        name: 'systemNotifications.settings',
        hiddenFooter: true,
        render: () => <SystemNotificationsSettings />,
      },
    },
  },
  screening: {
    route: '/screening',
    name: 'screening',
    hiddenFooter: true,
    render: () => <Screening />,
    components: {
      savedCriteria: {
        route: '/screening/savedCriteria',
        name: 'screening.savedCriteria',
        hiddenFooter: true,
        render: () => <Screening isSavedCriteriaScreen />,
      },
    },
  },
  userManagement: {
    components: {
      userProfile: {
        route: '/userManagement/userProfile',
        borderTopWhenResponsive: true,
        name: 'userManagement.userProfile',
        render: () => <UserProfile />,
        hiddenFooter: true,
      },
      settingsPreferences: {
        route: '/userManagement/settingsPreferences',
        borderTopWhenResponsive: true,
        name: 'userManagement.settingsPreferences',
        render: () => <SettingPreferences />,
        hiddenFooter: true,
      },
      subscriptionPayment: {
        route: '/userManagement/subscriptionPayment',
        name: 'userManagement.subscriptionPayment',
        render: () => <SubscriptionPayment />,
        hiddenFooter: true,
        components: {
          viewDetailPlan: {
            route: '/userManagement/subscriptionPayment/viewDetailPlan',
            name: 'userManagement.subscriptionPayment.viewDetailPlan',
            render: () => <ViewDetailPlan />,
            hiddenFooter: true,
          },
          packageList: {
            route: '/userManagement/subscriptionPayment/packageList',
            name: 'userManagement.subscriptionPayment.packageList',
            render: () => <PackageList />,
          },
          orderDetail: {
            route: '/userManagement/subscriptionPayment/orderDetail',
            name: 'userManagement.subscriptionPayment.orderDetail',
            render: () => <OrderDetail />,
            hiddenFooter: true,
          },
          requestDetail: {
            route: '/userManagement/subscriptionPayment/requestDetail',
            name: 'userManagement.subscriptionPayment.requestDetail',
            render: () => <RequestDetail />,
            hiddenFooter: true,
          },
        },
      },
      // comment engagementHistory Feature because BE undeveloped feature
      // engagementHistory: {
      //   route: '/userManagement/engagementHistory',
      //   name: 'userManagement.engagementHistory',
      //   render: () => <EngagementHistory />,
      //   hiddenFooter: true,
      //   borderTopWhenResponsive: true,
      // },
    },
    route: '/userManagement/userProfile',
  },
  connectMap: {
    route: '/connectMap',
    components: {
      entityMap: {
        route: '/connectMap/entityMap',
        name: 'connectMap.entityMap',
        hiddenFooter: true,
        borderTopWhenResponsive: true,
        render: () => <EntityMap />,
      },
      interconnectionMap: {
        route: '/connectMap/interconnectionMap',
        name: 'connectMap.interconnectionMap',
        hiddenFooter: true,
        borderTopWhenResponsive: true,
        render: () => <InterconnectionMap />,
      },
    },
  },
}
